import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { Ng9RutModule } from 'ng9-rut';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { SecurityService } from 'src/app/shared/services/security.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { SharedViewsModule } from '../shared/shared-views.module';
import { AuditoriaComponent } from "./auditoria/auditoria.component";
import { ListaAuditoriaComponent } from './auditoria/lista-auditoria/lista-auditoria.component';
import { BloqueoModuloActivoComponent } from './bloqueo-modulo-activo/bloqueo-modulo-activo.component';
import { CategoriasComponent } from "./categorias/categorias.component";
import { CuentasBancariasEmpresaComponent } from "./cuentas-bancarias-empresa/cuentas-bancarias-empresa.component";
import { ModulosComponent } from "./modulos/modulos.component";
import { OperacionesComponent } from "./operaciones/operaciones.component";
import { AgregarEditarParametroComponent } from './parametro/agregar-editar-parametro/agregar-editar-parametro.component';
import { ParametroComponent } from './parametro/parametro.component';
import { RolesComponent } from "./roles/roles.component";
import { SesionesActivasUsuariosComponent } from './sesiones-activas-usuarios/sesiones-activas-usuarios.component';
import { UsuariosComponent } from "./usuarios/usuarios.component";

@NgModule({
  declarations: [
    ModulosComponent,
    CategoriasComponent,
    OperacionesComponent,
    RolesComponent,
    UsuariosComponent,
    AuditoriaComponent,
    CuentasBancariasEmpresaComponent,
    ListaAuditoriaComponent,
    ParametroComponent,
    AgregarEditarParametroComponent,
    BloqueoModuloActivoComponent,
    SesionesActivasUsuariosComponent,
  ],
  imports: [
    CommonModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    Ng9RutModule,
    FormsModule,
    ReactiveFormsModule,
    SharedViewsModule,
    SharedModule,
    MatButtonModule,
    MatIconModule,
    InfiniteScrollModule
  ],
  exports: [
    ListaAuditoriaComponent,
  ],
  providers: [SecurityService, ValidadoresService],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class ConfiguracionSistemaModule { }
